(() => {
  if (customElements.get('gn-letter-personalizer')) return;

  const WIDTH = 1582;
  const HEIGHT = 2048;
  const NAME_MAX_WIDTH = 520;
  const CENTER_X = 1113;

  const loadImage = (url) => new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('Artwork could not be loaded. Please try again.'));
    image.src = url;
  });

  const formatDate = (value) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || value < '2024-01-15') return '';
    const [year, month, day] = value.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return '';
    return new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric' }).format(date);
  };

  const drawText = (ctx, name, date) => {
    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';
    ctx.fillStyle = '#2c2924';
    if (name) {
      let fontSize = 45;
      do {
        ctx.font = `${fontSize}px Georgia, 'Times New Roman', serif`;
        if (ctx.measureText(name).width <= NAME_MAX_WIDTH) break;
        fontSize -= 1;
      } while (fontSize >= 18);
      if (fontSize < 18) ctx.font = "18px Georgia, 'Times New Roman', serif";
      ctx.fillText(name, CENTER_X, 1738, NAME_MAX_WIDTH);
    }
    if (date) {
      ctx.font = "42px Georgia, 'Times New Roman', serif";
      ctx.fillText(date, CENTER_X, 1877, NAME_MAX_WIDTH);
    }
  };

  const drawPreviewWatermark = (ctx, width, height) => {
    ctx.save();
    ctx.translate(width / 2, height / 2);
    ctx.rotate(-Math.PI / 6);
    ctx.globalCompositeOperation = 'difference';
    ctx.fillStyle = 'rgba(255, 255, 255, 0.22)';
    ctx.font = `700 ${Math.round(Math.min(width * 0.12, height * 0.16))}px Arial, sans-serif`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    for (const offset of [-height * 0.28, 0, height * 0.28]) {
      ctx.fillText('PREVIEW', 0, offset, width * 0.7);
    }
    ctx.restore();
  };

  class LetterPersonalizer extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.nameInput = this.form?.querySelector('input[name="properties[Name to print]"]');
      this.dateInput = this.form?.querySelector('input[name="properties[Date of ordainment]"]');
      this.canvas = this.querySelector('canvas');
      this.error = this.querySelector('[role="alert"]');
      if (!this.form || !this.nameInput || !this.dateInput || !this.canvas) return;
      this.previewImage = loadImage(this.dataset.preview);
      this.previewImage.then(() => this.drawPreview()).catch((err) => this.showError(err.message));
      this.nameInput.addEventListener('input', () => this.drawPreview());
      this.dateInput.addEventListener('input', () => this.drawPreview());
    }

    showError(message) {
      this.error.textContent = message;
      this.error.hidden = !message;
    }

    async drawPreview() {
      try {
        const image = await this.previewImage;
        const ctx = this.canvas.getContext('2d');
        ctx.clearRect(0, 0, WIDTH, HEIGHT);
        ctx.drawImage(image, 0, 0, WIDTH, HEIGHT);
        ctx.globalCompositeOperation = 'multiply';
        ctx.fillStyle = '#faf3e7';
        ctx.fillRect(0, 0, WIDTH, HEIGHT);
        ctx.globalCompositeOperation = 'source-over';
        const name = this.nameInput.value.trim().replace(/\s+/g, ' ');
        const date = formatDate(this.dateInput.value);
        drawText(ctx, name, date);
        drawPreviewWatermark(ctx, WIDTH, HEIGHT);
        this.showError('');
      } catch (err) {
        this.showError(err.message);
      }
    }

  }

  customElements.define('gn-letter-personalizer', LetterPersonalizer);
})();
